import React, {Fragment, useState} from 'react';
import {observer} from "mobx-react";
import HeightPin from "../HeightPin";
import ScrollSection from "../ScrollSection";
import GemDiscover from "../elements/GemDiscover";
import MoodBoard from "../MoodBoard"
import ImageCirclePack from "../charts/ImageCirclePack";
import TreeMap from "../charts/TreeMap";
import CardFlip from "../elements/CardFlip";
import DidYouKnow from "../elements/DidYouKnow";
import {getAltText, getSectionImage, getInfoClass, getImageInfoStyle} from "../../assets/settings";

function Conclusion(props) {
    const {store, state, color, index, downhill} = props;
    const {circlePackStore} = store;

    const group = 'GA';
    const activeKey = store.activeSection(group) || 'CON_1';


    const sectionY = 0.35;

    const backgroundStyle = {
      backgroundImage: `url(img/AC/CON_background.jpg)`
    };

    return (
        <div className={'Section'}>
            <div className={'full'} style={backgroundStyle}>
                <h1>Conclusion - Graduation</h1>
                <p className={'bare'} style={{backgroundColor: color}}>
                  <h4>
                    How does the physical environment support the university’s core mission?
                  </h4>
                  <p>
                    The Campus Master Plan takes an in-depth look at current and projected need for academic spaces in order to make decisions about where additional buildings and rooms should be created on campus.
                  </p>
                </p>
            </div>
            <HeightPin store={store} state={state} scrollChild={<div className={'left-scroll'}>
                <div className={'spacer'} style={{height: 50}}/>

                <ScrollSection store={store} sectionY={sectionY} background={'none'} sectionGroup={group}
                               sectionKey={`CON_1`}>
                    <div style={getImageInfoStyle(color)} className={getInfoClass(activeKey, 'CON_1')}>
                      <h4>64% of campus space today is used for academics.</h4>
                      <p>
                        This pie chart shows the distribution of use within the existing campus.
                      </p>
                      <p>
                        Research, office, and conference space comprise the majority of academic space on-campus, with smaller allocations for instructional, study, and library stack space.
                      </p>
                    </div>
                </ScrollSection>
                <ScrollSection store={store} sectionY={sectionY} background={'none'} sectionGroup={group}
                               sectionKey={`CON_2`}>
                    <div style={getImageInfoStyle(color)} className={getInfoClass(activeKey, 'CON_2')}>
                        <p>
                          Which classrooms are crowded and used often?
                        </p>
                        <p>
                          This scatterplot shows two factors: how empty or crowded a classroom is, and how many hours a week it is used.
                        </p>
                        <p>
                          Each dot represents a classroom. The size and color show how many seats the classroom has: the smaller the dot, the fewer seats it has.
                        </p>
                        <p>
                          Looking left to right shows how often the classroom is scheduled: the further right a dot is, the more frequently used it is. Looking top to bottom shows how crowded the room is: the higher the dot, the more full the room is.
                        </p>
                    </div>
                </ScrollSection>
                <ScrollSection store={store} sectionY={sectionY} background={'none'} sectionGroup={group}
                               sectionKey={`CON_3`}>
                    <div style={getImageInfoStyle(color)} className={getInfoClass(activeKey, 'CON_3')}>
                      <p>
                        In general, rooms with 100 seats or more are the most used. Many of the most often used classrooms are in Dwinelle Hall. Dwinelle Hall also has the greatest number of classrooms of any other campus building.
                      </p>
                      <p>
                        General assignment classrooms, managed through the Registrar’s office, tend to be the most full and often used classrooms than departmentally- controlled rooms.
                      </p>
                      <DidYouKnow store={store} color={color}>
                          <p>Did you know that the smallest classroom on campus is in XXXX? The largest is in XXXX.</p>
                      </DidYouKnow>
                    </div>
                </ScrollSection>
                <ScrollSection store={store} sectionY={sectionY} background={'none'} sectionGroup={group}
                               sectionKey={`CON_4`}>
                    <div style={getImageInfoStyle(color)} className={getInfoClass(activeKey, 'CON_4')}>
                      <h4>
                        What types of additional academic life spaces are needed to improve the campus experience and help build community?
                      </h4>
                      <p>
                        A prior survey asked the Berkeley community to select which academic spaces they wanted to see added to campus.
                      </p>
                      <p>
                        Across all respondents, people chose individual study spaces as the number one need for academic space, followed by collaboration spaces/group study spaces and improved classrooms.
                      </p>
                    </div>
                </ScrollSection>
                <ScrollSection store={store} sectionY={sectionY} background={'none'} sectionGroup={group}
                               sectionKey={`CON_5`}>
                    <div style={getImageInfoStyle(color)} className={getInfoClass(activeKey, 'CON_5')}>
                      <h4>
                        How much additional space is needed to support academic life?
                      </h4>
                      <p>
                        Across all types (ex: classrooms, labs, office, etc.) there is a space deficit -- not enough space to meet demand.
                      </p>
                      <p>
                        The total estimated academic life deficits are 432,000 square feet to meet current demand, and 1.65 million square feet to met future demand.
                      </p>
                    </div>
                </ScrollSection>

                <div className={'spacer'} style={{height: '50vh'}}/>
            </div>}
                       pinChild={<div className={'sticky-image-right'}>
                           <div className={'frame'}>
                              {getAltText(activeKey).title && <h4 style={{'backgroundColor': color + '80'}}>{getAltText(activeKey).title}</h4>}
                               <img width={'100%'} src={getSectionImage(group, activeKey)} alt={getAltText(activeKey).alt} />
                           </div>
                       </div>}
            />
            <div className={'interactive'}>
                <CardFlip color={color} index={index} store={store}
                          frontFace={<MoodBoard store={store}/>}
                          backFace={<Fragment>
                              <h2>What everyone else said:</h2>
                              <ImageCirclePack store={store} circles={circlePackStore.packedCircles} width={circlePackStore.width}
                                               height={circlePackStore.height}/>
                              {/*<GemDiscover store={store} color={color} index={index}/>*/}

                          </Fragment>}/>
            </div>
        </div>
    );
}

export default observer(Conclusion);
